import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { getBackend } from "../../api/backend";
import { CircularProgress } from "@mui/material";

export default function FirstChart() {
  const [chartData, setChartData] = useState({ labels: [], data: {} });
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    try {
      const data = await getBackend("workorder-chart-data");
      setChartData(data);
    } catch (error) {
      console.error("Error fetching the chart data", error);
    }
  };

  useEffect(() => {
    fetchData().then(() => setIsLoading(false));
  }, []);

  return isLoading ? <CircularProgress /> : (
    <BarChart
      width={850}
      height={350}
      series={Object.keys(chartData.data).map((key) => ({
        data: chartData.data[key]["data"],
        label: key,
        id: key,
        stack: "work_orders",  
        color: chartData.data[key]["color"], 
      }))}  
      xAxis={[{
        data: chartData.labels, 
        scaleType: "band",
        label: "Ordenes de trabajo",
      }]}
      yAxis={[{ scaleType: undefined }]}
      borderRadius={8}
    />
  );
}
